import gsap from "../gsap";
import "hammerjs";

export const toggleCard = (e) => {
  e.preventDefault();

  const root = document.documentElement;
  const contentContainer = document.querySelector(".content-container");

  contentContainer.classList.toggle("is-open");
  root.classList.toggle("has-content-open");
};
export function bounceCarousel() {
  // Disabled because of https://dpi.plan.io/issues/20819.
  /*  let tl = gsap.timeline();
  tl.to(".content.active", {
    duration: 1.5,
    scrollTo: { x: 100, offsetX: 15 },
    overwrite: "auto",
    ease: "power2.in",
  });
  tl.to(".content.active", {
    duration: 1.5,
    scrollTo: { x: 0, offsetX: 15 },
    overwrite: "auto",
    ease: "power2.out",
  });*/
}
function getSlideDataByIndex(data, index) {
  for (let i = 0; i < data.length; i++) {
    if (i === index) {
      return data[i];
    }
  }
  return {};
}
function getMobilePartByIndex(data, index) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].id === `deel_${index}`) {
      return i;
    }
  }
  return -1;
}
export const slideCarouselToNextPart = (currSlidePos, callback) => {
  callback(currSlidePos + 1);
};
export const slideCarouselToPrevPart = (index, data, callback) => {
  callback(getMobilePartByIndex(data, index));
};
export const fillMobileCounter = (data, index) => {
  const slideData = getSlideDataByIndex(data, index);

  if (slideData.type === "part") {
    return `<span class="p">${slideData.title}</span>`;
  }
  if (slideData.type === "chapter") {
    return `<span class="p">${slideData.part_title}</span><span class="c">: H${slideData.chapter_count}</span>`;
  }
  if (slideData.type === "paragraph") {
    return `<span class="p">${slideData.part_title}</span><span class="c">: H${slideData.chapter_count}</span><span class="s">/P${slideData.paragraph_count}</span>`;
  }
  if (slideData.type === "summary") {
    return `<span class="s">Samenvatting</span>`;
  }
};
export const slideTo = (
  isNext,
  currSlidePos,
  slides,
  setMobileSlide,
  setCurrParagraph
) => {
  const currSlide = document.querySelector(
    ".content.active [data-slide='" + currSlidePos + "']"
  );

  const currSlideType = currSlide.dataset.type;

  if (isNext) {
    if (currSlidePos === slides.length) {
      return;
    }
    currSlidePos = currSlidePos + 1;
  } else {
    if (currSlideType === "part") {
      return;
    }
    currSlidePos = currSlidePos - 1;
  }
  const goToSlide = document.querySelector(
    ".content.active [data-slide='" + currSlidePos + "']"
  );

  if (goToSlide.dataset.type === "paragraph") {
    const paragraph = goToSlide.querySelector(".card--section");
    setCurrParagraph(paragraph.id);
  }
  setMobileSlide(currSlidePos);
};

const init = (currSlidePos, slides) => {
  let offsetX = 15;
  const navPrev = document.querySelector(".nav-prev");
  const navNext = document.querySelector(".nav-next");
  const currSlide = document.querySelector(
    "[data-slide='" + currSlidePos + "']"
  );
  const currSlideType = currSlide.dataset.type;
  let slideDuration = 0.8;
  let immediateRender = false;

  if (document.documentElement.classList.contains("has-content-open")) {
    slideDuration = 0;
    immediateRender = true;
  }

  const cardToggles = document.querySelectorAll(".card-toggle");
  cardToggles.forEach(function (cardToggle) {
    cardToggle.onclick = function (e) {
      toggleCard(e);
    };
  });

  if (currSlideType === "part") {
    navPrev.classList.add("disabled");
    navPrev.setAttribute("disabled", "disabled");
    navPrev.setAttribute("aria-disabled", "true");
  } else {
    navPrev.classList.remove("disabled");
    navPrev.removeAttribute("disabled");
    navPrev.setAttribute("aria-disabled", "false");
  }

  if (currSlideType === "summary") {
    navNext.classList.add("disabled");
    navNext.setAttribute("disabled", "disabled");
    navNext.setAttribute("aria-disabled", "true");
  } else {
    navNext.classList.remove("disabled");
    navNext.removeAttribute("disabled");
    navNext.setAttribute("aria-disabled", "false");
  }

  if (currSlideType === "summary") {
    offsetX = 0;
  }

  gsap.to(".content.active", {
    duration: slideDuration,
    scrollTo: { x: currSlide, offsetX: offsetX },
    overwrite: "auto",
    immediateRender: immediateRender,
  });

  // Correct slider position on resize (only for mobile).
  window.onresize = function () {
    if (
      Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      ) < 900
    ) {
      gsap.to(".content.active", {
        duration: 0,
        scrollTo: { x: currSlide, offsetX: offsetX },
        overwrite: "auto",
      });
    }
  };
};

export default init;
